import { render, staticRenderFns } from "./AppLauncher.vue?vue&type=template&id=01f87fe2&"
import script from "./AppLauncher.vue?vue&type=script&lang=js&"
export * from "./AppLauncher.vue?vue&type=script&lang=js&"
import style0 from "./AppLauncher.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/Volumes/ARCHIVE/Source/five9/ps-droids/packages/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01f87fe2')) {
      api.createRecord('01f87fe2', component.options)
    } else {
      api.reload('01f87fe2', component.options)
    }
    module.hot.accept("./AppLauncher.vue?vue&type=template&id=01f87fe2&", function () {
      api.rerender('01f87fe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/launcher/AppLauncher.vue"
export default component.exports